export default "__VITE_ASSET__CqkvuJ0U__"